module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("introduction")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "stickup"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "fontt"
  }, [_vm._v("HE GIFTS OF YOGA")]), _vm._v(" are as numerous and varied as the petals of a lotus blossom. Although yoga’s broader teachings touch on all aspects of life, it is asana practice that has made it immensely popular around the globe, and there is a good reason for it. Asana practice challenges the body and focuses the mind, while its philosophical principles encourage spiritual growth. Asanas can be viewed as a kind of prayer, and they have a significant and wholesome effect on our physical body, our psyche, and our emotional health. This distinguishes asana practice from other systematized forms of movement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This book provides the background myths for about thirty asanas. Asanas are often named after some ancient yogic sage, deity, or sacred animal. The myths behind the asanas are intended to serve as inspirational guides that can enhance our yoga practice, fueling it with a deeper, meditative quality. They provide us with a fresh perspective on ourselves, helping us connect our everyday lives with yoga through the postures.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All of the stories in this book illustrate some mystical, hidden potential within us. This potential tends to lie dormant until we illuminate it with awareness. To be mystical is to look within oneself for the source of all that is. In this sense the essence of the stories is found within the experience of our own hearts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Each of the characters in the myths displays human flaws, which make them easy to relate to. So as we read about the uncertainty of Hanuman before making his leap across the ocean, we are invited to think about the moments in our life when we felt the same way, when we called into question our potential and doubted our ability to achieve something we thought was not possible.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("These myths have been told since ancient times. Whether or not they actually happened is of less importance than the symbolic meaning they convey. The myths of ancient India concern themselves with the transformation of consciousness. Yoga and mythology scholar Mircea Eliade defined myths as “dramatic breakthroughs of the sacred into the world.” He noted that the language of myth does not argue, but simply presents. The myths of yoga’s spiritual tradition have the power to change old patterns of behavior, providing us with enlightened insight that brings us closer to who we really are. And this is precisely what the yoga tradition is concerned with. As Ecknath Easwaran put it, “yogic myth has a genius to clothe the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("infinite")]), _vm._v(" in human form.”")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The myths point to a higher state of consciousness. They depict the travel of the soul from ignorance to illumination. Their goal is to take us from the illusions of our ego-centered existence ("), _c('span', {
    staticClass: "txit"
  }, [_vm._v("samsara")]), _vm._v(") to the reality of liberated existence, which has three main components: truth ("), _c('span', {
    staticClass: "txit"
  }, [_vm._v("sat")]), _vm._v("), clear consciousness ("), _c('span', {
    staticClass: "txit"
  }, [_vm._v("cit")]), _vm._v("), and boundless joy ("), _c('span', {
    staticClass: "txit"
  }, [_vm._v("ananda")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The myths behind the asanas have much to teach us. Meditating on the tolerance of trees can actually inspire us to become more tolerant. Hearing about how the disfigured Astavakra came to be the teacher of a king can diminish our concern with our external appearance and our self-imposed limitations. Marveling at the devotion of Hanuman can help us gain some of the spiritual strength and determination he represents. Through the myths, the asanas can become true vehicles for transformation. We hope this book will help you add a new dimension to your practice, understanding, and love of yoga.")]), _vm._v(" "), _c('p', {
    staticClass: "imagea"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com-02.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d55afcc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/intro.vue
// module id = 69
// module chunks = 0